import React from "react";
import EditParticipationForm from "./EditParticipationForm";
import { format } from "date-fns";

import { FiEdit2, FiTrash2 } from "react-icons/fi";

export default function ParticipationList({
    participations,
    onEdit,
    onDelete,
    editingIndex,
    onSave,
    onCancel,
}) {
    if (editingIndex !== null) {
        const item = participations[editingIndex];
        return (
            <EditParticipationForm
                data={item}
                index={editingIndex}
                onSave={onSave}
                onCancel={onCancel}
            />
        );
    }

    return (
        <ul >
            {participations.map((item, i) => (
                <li key={i} className="participation-item">
                    <strong>{item.name}</strong><br />
                    ({item.level})<br />

                    {item.achievement}<br />

                    <small>
                        {format(item.date_start?.toDate(), "dd MMM yyyy")} to {format(item.date_end?.toDate(), "dd MMM yyyy")}
                    </small>

                    <p><strong>Location:</strong> {item.location}</p>

                    {item.media?.map((url, index) => (
                        <img key={index} src={url} alt={`Media ${index}`} />
                    ))}

                    <div className="participation-buttons" style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
                        <FiEdit2
                            onClick={() => onEdit(i)}
                            title="Edit"
                            style={{ cursor: "pointer" }}
                            size={18}
                        />
                        <FiTrash2
                            onClick={() => {
                                const confirmDelete = window.confirm("Are you sure you want to delete this participation?");
                                if (confirmDelete) onDelete(i);
                            }}
                            title="Delete"
                            style={{ cursor: "pointer", color: "red" }}
                            size={18}
                        />

                    </div>

                </li>
            ))}
        </ul>
    );
}